export default __webpack_public_path__ + "static/media/clock_circle.54223018.svg";